import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Toast = {
  placement: 'top',
  defaultProps: {
    hasTint: true,
    showCloseButton: true,
    hasHorizontalBar: true
  },
  base: css(["border-radius:0px;width:480px;@media screen and (max-width:", "px){width:90vw;}"], theme('fannypack.layout.mobileBreakpoint')),
  Title: {
    base: css(["&&{font-size:1rem;}"])
  }
};
export default Toast;